import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Get Expert Advice',
  name: 'getExpertAdvice',
  type: 'document',
  fields: [
    defineField({
      title: 'Above Title',
      name: 'aboveTitle',
      type: 'string',
    }),
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Button',
      type: 'link',
      name: 'button',
    }),
  ],
  preview: {
    select: {
      title: 'title',
      aboveTitle: 'aboveTitle',
    },
    prepare({ title, aboveTitle }) {
      return {
        title: title || 'Get Expert Advice',
        subtitle: aboveTitle || 'Expert Advice Configuration',
      }
    },
  },
})